import ReactDOM from 'react-dom/client';
import React from 'react';
const rootEl = document.getElementById('subscriptionsConfigurator');
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import TranslationsContext from './TranslationsContext';

const translations = typeof window !== 'undefined' && window['__SUBSCRIPTIONS_CONFIGURATOR_T__'] ? window['__SUBSCRIPTIONS_CONFIGURATOR_T__'] : {};

function decodeHtmlEntities(str) {
	if (typeof str !== 'string') return str;
	const el = document.createElement('textarea');
	el.innerHTML = str;
	return el.value;
}

function t(key, vars) {
	let str = translations[key];
	if (str == null) str = key;
	if (vars && typeof str === 'string') {
		Object.keys(vars).forEach(function (k) {
			str = str.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), String(vars[k]));
		});
	}
	return decodeHtmlEntities(str);
}

const sectionsAlreadyOnThePage = {
	1: document.getElementById('firstPage')?.innerHTML ?? '',
	4: document.getElementById('lastPage')?.innerHTML ?? '',
	5: document.getElementById('thankYouPage')?.innerHTML ?? '',
};

const pagePlaceholder = document.getElementById('pagePlaceholder')?.innerHTML ?? '';
const thankYouPageEl = document.getElementById('thankYouPage');
const thankYouPageHandle = thankYouPageEl?.dataset?.templateThankYouPage ?? false;
const configuratorEl = document.getElementById('subscriptionsConfigurator');
const titleObject = JSON.parse(configuratorEl?.dataset?.titleObject ?? '{}');
const logoUrl = configuratorEl?.dataset?.logoUrl ?? '';

if (rootEl) {
	const root = ReactDOM.createRoot(rootEl);
	root.render(
		<React.StrictMode>
			<TranslationsContext.Provider value={t}>
				<BrowserRouter>
					<App
						sectionsAlreadyOnThePage={sectionsAlreadyOnThePage}
						pagePlaceholder={pagePlaceholder}
						thankYouPageHandle={thankYouPageHandle}
						tableType={rootEl.dataset.tableType}
						subscriptionDisplay={rootEl.dataset.subscriptionDisplay}
						titleObject={titleObject}
						logoUrl={logoUrl}
					/>
				</BrowserRouter>
			</TranslationsContext.Provider>
		</React.StrictMode>,
	);
}
